import { Reveal, Overline } from "./Reveal";

const industries = [
  { name: "Telecom", img: "https://images.pexels.com/photos/2352277/pexels-photo-2352277.jpeg", span: "md:col-span-2" },
  { name: "Manufacturing", img: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b" },
  { name: "Energy", img: "https://images.pexels.com/photos/12939551/pexels-photo-12939551.jpeg" },
  { name: "Automotive / EV", img: "https://images.pexels.com/photos/24376862/pexels-photo-24376862.jpeg" },
  { name: "Healthcare", img: "https://images.unsplash.com/photo-1639322537228-f710d846310a" },
  { name: "Enterprise IT", img: "https://images.pexels.com/photos/12939551/pexels-photo-12939551.jpeg" },
  { name: "Service Providers", img: "https://images.pexels.com/photos/18419508/pexels-photo-18419508.jpeg", span: "md:col-span-2" },
];

export const Industries = () => (
  <section id="industries" className="relative z-10 border-t border-white/10 bg-ink-950 py-24 md:py-32" data-testid="industries-section">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal><Overline>Industries Served</Overline></Reveal>
      <Reveal delay={0.05}>
        <h2 className="mt-6 max-w-2xl font-display text-3xl font-bold tracking-tighter text-white sm:text-4xl md:text-5xl">
          Trusted across the sectors building the future.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-4">
        {industries.map((ind, i) => (
          <Reveal
            key={ind.name}
            delay={(i % 4) * 0.06}
            className={`group relative h-56 overflow-hidden rounded-2xl border border-white/10 sm:h-64 ${ind.span || ""}`}
            data-testid={`industry-${i}`}
          >
            <img
              src={ind.img}
              alt={ind.name}
              className="absolute inset-0 h-full w-full object-cover grayscale transition-all duration-700 group-hover:scale-110 group-hover:grayscale-0"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/40 to-transparent" />
            <div className="absolute bottom-0 left-0 p-6">
              <h3 className="font-display text-xl font-semibold tracking-tight text-white sm:text-2xl">{ind.name}</h3>
              <span className="mt-1 block h-0.5 w-0 bg-brand transition-all duration-500 group-hover:w-12" />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
